const HISTORY = {
  ADDED: 'added',
  EDITED: 'edited',
  DELETED: 'deleted',

  LOCATION: 'location',
  RING: 'ring',
};

export default HISTORY;



// WEBPACK FOOTER //
// ./src/const/history.js